import { useTasksByGoalId } from 'features/tasks';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Section, Sizes } from 'shared/components/ui/section';
import { TasksList } from 'shared/components/ui/tasks-list';
import { Goal } from 'shared/types/goal';

export type CompletedTasksListProps = {
  goal: Goal;
};

export const CompletedTasksList: React.FC<CompletedTasksListProps> = ({
  goal,
}) => {
  const { t } = useTranslation();
  const tasks = useTasksByGoalId(goal.id);
  const completedTasks = useMemo(
    () =>
      tasks
        .filter((task) => task.completedAt)
        .toSorted(
          (taskA, taskB) =>
            (taskA.completedAt?.getTime() ?? 0) -
            (taskB.completedAt?.getTime() ?? 0),
        ),
    [tasks],
  );

  if (!completedTasks.length) {
    return null;
  }

  return (
    <Section
      title={t('pages.goal-detail.tasks.completed.title')}
      titleCount={completedTasks.length}
      size={Sizes.Small}
      canCollapse
    >
      <TasksList tasks={completedTasks} hideGoal />
    </Section>
  );
};
